export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13945.af9855a2.jpg";